// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { BridgeAgreement } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/Bridge';
import {
  BridgeUserAgreementRequest,
  RejectedBridgeUserAgreementRequest,
} from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/User/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRejectBridgeUserAgreement: () => UseMutationResult<
  ContractId<RejectedBridgeUserAgreementRequest>,
  string,
  {
    bridgeAgreementCid: ContractId<BridgeAgreement>;
    bridgeUserAgreementRequestCid: ContractId<BridgeUserAgreementRequest>;
    reason: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['rejectBridgeUserAgreement', ledgerApi],
    mutationFn: async ({ bridgeAgreementCid, bridgeUserAgreementRequestCid, reason }) => {
      return ledgerApi.rejectBridgeUserAgreement(
        bridgeAgreementCid,
        bridgeUserAgreementRequestCid,
        reason,
      );
    },
  });
};

export default useRejectBridgeUserAgreement;
